{
  "save": "Save",
  "cancel": "Cancel",
  "submit": "Submit",
  "loading": "Loading...",
  "ok": "OK",
  "add": "Add",
  "continue": "Continue",
  "select": "Select...",
  "selectedCount": "{{count}} selected",
  "notAvailable": "N/A",
  "close": "Close",
  "compressingImage": "Compressing image...",
  "hide": "Hide",
  "show": "Show",
  "applying": "Applying...",
  "back": "Back",
  "delete": "Delete",
  "duplicate": "Duplicate",
  "lock": "Lock",
  "mixed": "Mixed",
  "multipleValues": "Multiple values",
  "next": "Next",
  "or": "or",
  "remove": "Remove",
  "unlock": "Unlock",
  "units": {
    "meters": "Meters",
    "feet": "Feet"
  },
  "sandbox": {
    "title": "{{name}}'s Sandbox",
    "badge": "Sandbox",
    "section": "Your Sandbox",
    "description": "A private space to learn and experiment"
  }
}
